import Pristine from 'pristinejs';
import jump from 'jump.js';

Alpine.data('contactUs', (endpoint) => {
	const pristineConfig = {
		classTo: 'gfield',
		errorClass: 'gfield_error',
		successClass: 'gfield_success',
		errorTextParent: 'gfield',
		errorTextTag: 'div',
		errorTextClass: 'gfield_validation_message',
	};

	const formTrackingDetails = {
		interactionStartTime: null,
		isDirty: false,
		fieldHistory: [],
		isNotSubmit: true,
	};

	return {
		inputs: {
			url: window.location.href,
			enquiryType: [],
			inEU: null,
			country: null,
		},
		processing: false,
		error: null,
		successful: false,

		init() {
			setTimeout(() => {
				this.$store.aa.observeFormInteraction(
					this.$refs.form,
					formTrackingDetails
				);
				this.$store.aa.trackFormAbandonment(formTrackingDetails, {
					form_name: 'contact',
					form_variant: 'standard',
				});
			}, 1000);

			return () => {
				this.inputs.inEU = this.$store.aa.userInEU;

				this.$watch('inputs.country', () => {
					this.$store.aa.isEU(this.inputs.country).json((response) => {
						this.inputs.inEU = response.data;
					});
				});
			};
		},
		postToCRM() {
			this.processing = true;
			this.error = null;

			this.$store.aa
				.api(endpoint)
				.post({
					...this.inputs,
				})
				.json((response) => {
					this.processing = false;

					if (response.success) {
						this.successful = true;

						this.scrollToTop();

						this.$store.aa.track({
							event: 'form_submit',
							form_name: 'contact',
							form_variant: 'standard',
							submit_type: this.inputs.enquiryType,
						});

						formTrackingDetails.isNotSubmit = false;
					} else {
						this.error = response.message || null;
					}
				})
				.catch((response) => {
					this.processing = false;

					this.error = response?.json?.message || response?.message;
				});
		},
		handleSubmit() {
			const validator = new Pristine(this.$refs.form, pristineConfig);
			const valid = validator.validate();

			if (valid) {
				// Validate via Turnstile and submit to CRM.
				this.$store.turnstile.render({
					element: this.$refs.turnstile,
					callback: (token, fieldName) => {
						this.inputs[fieldName] = token;

						this.postToCRM();
					},
					action: 'contact-us',
					autoRemove: true,
				});
			} else {
				this.scrollToFirstErrorMessage(validator);

				this.$store.aa.trackFormErrors(formTrackingDetails, validator, {
					form_name: 'contact',
				});
			}
		},
		scrollToTop() {
			jump(this.$root, {
				duration: 300,
				offset: -100,
				a11y: true,
			});
		},
		scrollToFirstErrorMessage(pristineInstance) {
			const fistInvalidControl = pristineInstance.getErrors()[0];

			fistInvalidControl &&
				fistInvalidControl.input &&
				jump(fistInvalidControl.input, {
					duration: 300,
					offset: -200,
					a11y: true,
				});
		},
	};
});
